export default __webpack_public_path__ + "static/media/marke_3.fc383028.png";